export const TIER_LEVELS = {
  FREE: 1,
  TRIAL: 10,
  PAID: 20,
  ENTERPRISE: 30,
} as const;

export type TierLevel = (typeof TIER_LEVELS)[keyof typeof TIER_LEVELS];

export const DEFAULT_TRIAL_DAYS = 14;

export const ORG_PERMISSIONS = {
  OWNER: 'owner',
  USER: 'user',
} as const;

export const TIER_LEVEL_TO_TITLE = {
  [TIER_LEVELS.FREE]: 'Developer',
  [TIER_LEVELS.TRIAL]: 'Team',
  [TIER_LEVELS.PAID]: 'Team',
  [TIER_LEVELS.ENTERPRISE]: 'Enterprise',
} as const;

export const PLAN_NAMES = Object.freeze({
  DEVELOPER: 'Developer',
  TEAMS: 'Teams',
  ENTERPRISE: 'Enterprise',
});
